import { useMe } from 'src/services/user';
import { trpc } from 'src/utils/trpc';

interface OrganizationPermissionProps {
  children?: React.ReactNode;
  vehicle_id?: string;
  feature_flag?: string;
}

export const OrganizationPermission: React.FC<OrganizationPermissionProps> = ({
  children,
  vehicle_id = null,
  feature_flag = '',
}) => {
  const { me } = useMe();
  try {
    if (!feature_flag) return null;

    const { data } =
      trpc.organizations.getOrgFeatureFlagsByVehicleIdOrOrgId.useQuery(
        {
          vehicle_id,
          organization_id: me?.organization?.id || '',
        },
        {
          keepPreviousData: true,
          refetchOnWindowFocus: false,
        }
      );

    const feature_flags = data?.feature_flags as string[];

    if (!feature_flags?.includes(feature_flag)) return null;

    return <>{children}</>;
  } catch (error) {
    console.error('Error in OrganizationPermission', error);
    return null;
  }
};
